<template>
  <div class="hvh-table-container">
    <v-card elevation="3" class="hvh-card--rounded">
      <v-expansion-panel :value="expandedValue">
        <v-expansion-panel-content>
          <template v-slot:header>
            <slot name="expansion-heading" />
          </template>
          <v-data-table :headers="headers" :items="tableData" :pagination.sync="pagination" :hideActions="tableData.length <= 50" :must-sort="true" class="hvh-table">
            <template v-slot:items="props">
              <tr @click="$emit('table-row-click', props)" v-right-click-menu="`/Analytics/CohortAnalyticRun/${props.item.id}/Result`">
                <td>
                  <hvh-analysis-type-chip :type="props.item.type" :colors="analyticColors" />
                </td>
                <td>{{ props.item.details }}</td>
                <td>
                  <span class="hvh-date">{{ dateFormatter(props.item.createdDate) }}</span>
                </td>
                <td>
                  <span class="hvh-date">{{ dateFormatter(props.item.lastRunDate) }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['tableData', 'expanded', 'dateFormatter', 'analyticColors'],
  data(self) {
    return {
      expandedValue: self.expanded === true ? 0 : 1,
      headers: [
        {
          text: 'Analysis Type',
          value: 'type',
          align: 'left',
          class: ['hvh-table-header hvh-table-header--sm']
        },
        {
          text: 'Details',
          value: 'details',
          align: 'left',
          class: ['hvh-table-header']
        },
        { text: 'Cohort Version', value: 'createdDate', class: ['hvh-table-header'] },
        { text: 'Completed', value: 'lastRunDate', class: ['hvh-table-header'] }
      ],
      pagination: {
        descending: true,
        sortBy: 'lastRunDate',
        page: 1,
        rowsPerPage: 50,
      }
    };
  },
};
</script>
